<template>
  <section class="px-4 py-20 md:px-6 md:py-28">
    <div class="mx-auto max-w-6xl">
      <div class="mb-10 text-center">
        <h2 class="text-4xl font-bold text-foreground md:text-5xl">
          {{ $ts('faq.title') }}
        </h2>
      </div>

      <div class="divide-y divide-border/60 overflow-hidden rounded-2xl border border-border/60">
        <div v-for="(faq, index) in faqs" :key="index">
          <button
            type="button"
            class="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors hover:bg-muted/40"
            @click="openFaqs.has(index) ? openFaqs.delete(index) : openFaqs.add(index)"
          >
            <span class="text-lg font-semibold text-foreground md:text-xl">{{ faq.q }}</span>
            <Icon
              name="tabler:chevron-down"
              size="20"
              class="shrink-0 text-foreground transition-transform duration-200"
              :class="{ 'rotate-180': openFaqs.has(index) }"
            />
          </button>
          <Transition
            enter-active-class="transition-all duration-200 ease-out"
            enter-from-class="opacity-0 max-h-0"
            enter-to-class="opacity-100 max-h-96"
            leave-active-class="transition-all duration-150 ease-in"
            leave-from-class="opacity-100 max-h-96"
            leave-to-class="opacity-0 max-h-0"
          >
            <div v-if="openFaqs.has(index)" class="overflow-hidden border-t border-border/60 px-6 py-5">
              <p class="text-base leading-relaxed text-foreground">{{ faq.a }}</p>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { reactive, computed } from 'vue';
import { useI18n, useSchemaOrg, defineQuestion } from '#imports';

const { $ts } = useI18n();

const faqs = computed(() => [
  { q: $ts('faq.q1'), a: $ts('faq.a1') },
  { q: $ts('faq.q2'), a: $ts('faq.a2') },
  { q: $ts('faq.q3'), a: $ts('faq.a3') },
  { q: $ts('faq.q4'), a: $ts('faq.a4') },
  { q: $ts('faq.q5'), a: $ts('faq.a5') },
]);

const openFaqs = reactive(new Set<number>([0]));

useSchemaOrg([
  ...faqs.value.map(faq => defineQuestion({ name: faq.q, acceptedAnswer: faq.a })),
]);
</script>
